import { Button } from "antd";
import { BusinessInfoSteps } from "..";

import styles from "../../../Partnership.module.scss";

interface IAddBusinessOwnerAction {
  handleNextStep: (_step: BusinessInfoSteps) => void;
}

const AddBusinessOwnerAction: React.FC<IAddBusinessOwnerAction> = ({
  handleNextStep,
}) => {
  return (
    <div className={styles.RegisteredBusinessAction}>
      <div className={styles.ActionContainer}>
        <Button
          type="primary"
          size="large"
          className={styles.ActionButton}
          onClick={() =>
            handleNextStep(BusinessInfoSteps.ADD_BUSINESS_OWNER_STEPS)
          }
        >
          Add Partner
        </Button>
        {/* Add via email functionality not available in admin yet */}
        {/* <p onClick={() => setIsAddViaEmailOpen(true)}>Add via email</p> */}
      </div>
    </div>
  );
};

export default AddBusinessOwnerAction;
